import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const deletePostByPostId = async ({ postId }) => {
	try {
		const postDocRef = firestore.collection('posts').doc(postId)
		return await postDocRef.update({ deleted: true, modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp() })
	} catch (error) {
		return Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, postId, error))
	}
}

export default deletePostByPostId



// WEBPACK FOOTER //
// ./src/dataservices/deletePostByPostId.js